<template>
    <div id="landing-banner">
        <!--=====================================-->
        <!--=        Project Area Start         =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div class="project-add-banner" data-sal="slide-up" data-sal-duration="800">
                    <div class="content">
                        <h1 class="white">
                            Promueve la inversión de impacto y genera ingresos pasivos.
                        </h1>
                        <h6 class="font-weight-100 white h5 w-75">
                            Gana hasta un 3% anual (pagado mensualmente) sobre la inversión de tus referidos.
                        </h6>
                        <button @click.stop="goToInvestorRegister" class="axil-btn btn-primary rg-style-button">Regístrate</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "LandingBanner",
    components: {
    },
    data() {
        return {
            banner: "https://cdn.redgirasol.com/nuevo_portal/banners/banner-promoters.png"
        }
    }
}

</script>

<style scoped>

.project-add-banner {
    background-image: url("https://cdn.redgirasol.com/nuevo_portal/banners/banner-promoters.png") !important;
    background-size: cover;
    background-position: center;
}
</style>